import * as React from 'react';
import {connect} from "react-redux";
import {CONTACT_TAB} from '../../../Config/appConfig';
import {ReduxUpdatedState} from '../../../Config/dataModel';
import userManagementDispatch from '../../../ReduxRequests/Dispatch/userManagementDispatch';
import userManagementState from '../../../ReduxRequests/State/userManagementState';
import authState from '../../../ReduxRequests/State/authState';
import ContactBannerButton from './ContactBannerButton';
import * as moment from 'moment';
import '../../../style/contactTab.css';

const mapStateToProps = (state) => {
    return {
        ...userManagementState(state),
        ...authState(state)
    }
};

interface ContactTabProps {
    currentTab: string,
    updatedTime?: moment.Moment,
    changeUpdateStatus?: () => void,
    isInsurer?: () => boolean,
    fetchInsurerCount?: () => void,
    companyCount?: ReduxUpdatedState,
    normalUserCount?: ReduxUpdatedState,
    apiUserCount?: ReduxUpdatedState,
    fetchSubagentCount?: () => void,
    fetchNormalUserCount?: () => void,
    fetchApiUserCount?: () => void
}

interface ContactTabState {
    companyCount: string,
    normalUserCount: string,
    apiUserCount: string
}

class ContactTab extends React.Component <ContactTabProps, ContactTabState> {
    public componentMountedAt : moment.Moment = moment();

    public constructor(props: ContactTabProps) {
        super(props);
        this.state = {
            companyCount: '-',
            normalUserCount: '-',
            apiUserCount: '-'
        };
    }

    public componentDidMount() {
        this.getCompanyCount();
        this.getNormalUserCount();
        this.getApiUserCount();
    }

    public componentWillReceiveProps(nextProps: ContactTabProps) {
        if (nextProps.companyCount && nextProps.companyCount.updatedAt.isAfter(this.componentMountedAt) && nextProps.companyCount.value.toString() !== this.state.companyCount) {
            this.setState({
                companyCount: nextProps.companyCount.value
            });
        }
        if (nextProps.normalUserCount && nextProps.normalUserCount.updatedAt.isAfter(this.componentMountedAt) && nextProps.normalUserCount.value.toString() !== this.state.normalUserCount) {
            this.setState({
                normalUserCount: nextProps.normalUserCount.value
            });
        }
        if (nextProps.apiUserCount && nextProps.apiUserCount.updatedAt.isAfter(this.componentMountedAt) && nextProps.apiUserCount.value.toString() !== this.state.apiUserCount) {
            this.setState({
                apiUserCount: nextProps.apiUserCount.value
            });
        }
        if (nextProps.updatedTime && nextProps.updatedTime !== this.props.updatedTime) {
            switch (this.props.currentTab) {
                case CONTACT_TAB.COMPANY:
                    this.getCompanyCount();
                    break;
                case CONTACT_TAB.NORMAL_USER:
                    this.getNormalUserCount();
                    break;
                case CONTACT_TAB.API_USER:
                    this.getApiUserCount();
                    break;
            }
            this.props.changeUpdateStatus();
        }
    }

    public getCompanyCount() {
        this.props.isInsurer() ? this.props.fetchSubagentCount() : this.props.fetchInsurerCount();
    }

    public getNormalUserCount() {
        this.props.fetchNormalUserCount();
    }

    public getApiUserCount() {
        this.props.fetchApiUserCount();
    }

    public render() {
        return (
            <div className="contactTab">
                <ContactBannerButton
                    buttonType={CONTACT_TAB.COMPANY}
                    count={this.state.companyCount}
                    title={`${this.props.isInsurer() ? "Sub-agent" : "Insurance"} Companies`}
                    isSelected={this.props.currentTab === CONTACT_TAB.COMPANY}/>
                <ContactBannerButton
                    buttonType={CONTACT_TAB.NORMAL_USER}
                    count={this.state.normalUserCount}
                    title="Company Users"
                    isSelected={this.props.currentTab === CONTACT_TAB.NORMAL_USER}/>
                <ContactBannerButton
                    buttonType={CONTACT_TAB.API_USER}
                    count={this.state.apiUserCount}
                    title="Company API Users"
                    isSelected={this.props.currentTab === CONTACT_TAB.API_USER}/>
            </div>
        );
    }
}

export default connect<any, any, ContactTabProps>(mapStateToProps, userManagementDispatch)(ContactTab);



// WEBPACK FOOTER //
// ./src/Components/Contact/Tab/ContactTab.tsx